import {
    FETCH_APPLICATION_GUIDES,
    FETCH_APPLICATION_GUIDES_SUCCESS,
    FETCH_APPLICATION_GUIDES_ERROR,
    SET_GUIDES_SEARCH_TERM,
    REMOVE_GUIDE,
    REMOVE_GUIDE_SUCCESS,
    REMOVE_GUIDE_ERROR,
    DUPLICATE_GUIDE,
    DUPLICATE_GUIDE_SUCCESS,
    DUPLICATE_GUIDE_ERROR,
    UPDATE_GUIDE,
    UPDATE_GUIDE_SUCCESS,
    UPDATE_GUIDE_ERROR,
    EDIT_GUIDE_HOST,
    EDIT_GUIDE_HOST_SUCCESS,
    EDIT_GUIDE_HOST_ERROR,
    CREATE_GUIDE,
    CREATE_GUIDE_SUCCESS,
    CREATE_GUIDE_ERROR,
    UPDATE_TOUR,
    UPDATE_TOUR_SUCCESS,
    UPDATE_TOUR_FAIL,
    FETCH_GUIDE_RULES,
    FETCH_GUIDE_RULES_SUCCESS,
    FETCH_GUIDE_RULES_ERROR,
    UPDATE_GUIDE_RULES,
    UPDATE_GUIDE_RULES_SUCCESS,
    UPDATE_GUIDE_RULES_ERROR,
    FETCH_ATTRIBUTES_FOR_RULE_REQUEST,
    FETCH_ATTRIBUTES_FOR_RULE_SUCCESS,
    FETCH_ATTRIBUTES_FOR_RULE_ERROR,
    FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST,
    FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS,
    FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR,
} from './constants';

export const fetchApplicationGuides = (appId, filters) => ({
    type: FETCH_APPLICATION_GUIDES,
    payload: { appId, filters },
});

export const fetchApplicationGuidesSuccess = (data) => ({
    type: FETCH_APPLICATION_GUIDES_SUCCESS,
    payload: { data },
});

export const fetchApplicationGuidesError = () => ({
    type: FETCH_APPLICATION_GUIDES_ERROR,
});

export const setGuidesSearchTerm = (searchTerm) => ({
    type: SET_GUIDES_SEARCH_TERM,
    payload: { searchTerm },
});

export const removeGuide = (payload) => ({
    type: REMOVE_GUIDE,
    payload,
});

export const removeGuideSuccess = (payload) => ({
    type: REMOVE_GUIDE_SUCCESS,
    payload,
});

export const removeGuideError = () => ({
    type: REMOVE_GUIDE_ERROR,
});

export const duplicateGuide = (payload) => ({
    type: DUPLICATE_GUIDE,
    payload,
});

export const duplicateGuideSuccess = (payload, sourceGuideId) => ({
    type: DUPLICATE_GUIDE_SUCCESS,
    payload: { data: payload, sourceGuideId },
});

export const duplicateGuideError = (payload) => ({
    type: DUPLICATE_GUIDE_ERROR,
    payload,
});

export const updateGuide = (guide, data, message, secondMessage) => ({
    type: UPDATE_GUIDE,
    payload: { guide, data, message, secondMessage },
});

export const updateGuideSuccess = (guide, data) => ({
    type: UPDATE_GUIDE_SUCCESS,
    payload: { guide, data },
});

export const updateGuideError = () => ({
    type: UPDATE_GUIDE_ERROR,
});

export const editGuideHost = (guideId, data, message) => ({
    type: EDIT_GUIDE_HOST,
    payload: { data, message, guideId },
});

export const editGuideHostSuccess = (guideId, data, isSameApplication) => ({
    type: EDIT_GUIDE_HOST_SUCCESS,
    payload: { guideId, data, isSameApplication },
});

export const editGuideHostError = () => ({
    type: EDIT_GUIDE_HOST_ERROR,
});

export const createNewGuide = (payload, message) => ({
    type: CREATE_GUIDE,
    payload,
    message,
});

export const createNewGuideSuccess = (payload) => ({
    type: CREATE_GUIDE_SUCCESS,
    payload,
});

export const createNewGuideError = () => ({
    type: CREATE_GUIDE_ERROR,
});

export const updateTour = (tour, values, message) => ({
    type: UPDATE_TOUR,
    payload: { tour, values },
    message,
});

export const updateTourSuccess = (id, data) => ({
    type: UPDATE_TOUR_SUCCESS,
    payload: { id, data },
});

export const updateTourError = () => ({
    type: UPDATE_TOUR_FAIL,
});

export const fetchGuideRules = (guideId, message) => ({
    type: FETCH_GUIDE_RULES,
    payload: { guideId },
    message,
});

export const fetchGuideRulesSuccess = (payload) => ({
    type: FETCH_GUIDE_RULES_SUCCESS,
    payload,
});

export const fetchGuideRulesError = (error) => ({
    type: FETCH_GUIDE_RULES_ERROR,
    payload: error,
});

export const updateGuideRules = (guide, data, message) => ({
    type: UPDATE_GUIDE_RULES,
    payload: { guide, data },
    message,
});

export const updateGuideRulesSuccess = (data, guideId) => ({
    type: UPDATE_GUIDE_RULES_SUCCESS,
    payload: { data, guideId },
});

export const updateGuideRulesError = () => ({
    type: UPDATE_GUIDE_RULES_ERROR,
});

export const fetchAttributesForRuleRequest = () => ({
    type: FETCH_ATTRIBUTES_FOR_RULE_REQUEST,
});

export const fetchAttributesForRuleSuccess = (payload) => ({
    type: FETCH_ATTRIBUTES_FOR_RULE_SUCCESS,
    payload,
});

export const fetchAttributesForRuleError = () => ({
    type: FETCH_ATTRIBUTES_FOR_RULE_ERROR,
});

export const fetchContextOptionsForRuleRequest = () => ({
    type: FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST,
});

export const fetchContextOptionsForRuleSuccess = (payload) => ({
    type: FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS,
    payload,
});

export const fetchContextOptionsForRuleError = () => ({
    type: FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR,
});
